import React from 'react'

const CartItem = ({item}) => {
    const progressWidth = item.value + "%";
    const id = item.id;
    const colors = ['#272075', '#208320', '#FF0000'];
    const widthStyle ={
        width: progressWidth,
        background: colors[id-1],
    }
  return (
    <>
        <div className="cartItem">
            <div className="itemHead">
                <p>{item.heading}</p>
                <p>{item.value}%</p>
            </div>
            <div className="progressBar">
                <div className="progress" style={widthStyle}></div>
            </div>
        </div>
    </>
  )
}

export default CartItem